import { render } from "./AwesomeIcon.vue?vue&type=template&id=c0df216c"
import script from "./AwesomeIcon.vue?vue&type=script&lang=js"
export * from "./AwesomeIcon.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\mihne\\Desktop\\matrixWork\\individual\\datacenter\\printqMatrix\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__